import { ICapiFormInput } from '../hooks/useCapiFormValidation'
import { IChargerInformationFormInput, IChargerSettingsFormInput } from '../hooks/useChargePointInfoValidation'
import { ChargePoint, Connector } from '../redux/api/web-api'
import { IOcppFormInput } from '../hooks/useOcppFormValidation'

export function mapOcppChargepoint(chargePoint: ChargePoint, formValues: IOcppFormInput): ChargePoint {
    const tempChargePoint = JSON.parse(JSON.stringify(chargePoint))

    const connectors = tempChargePoint.connectors?.map((connector: Connector) => {
        const connectorId = connector.connectorId
        connector.externalId = formValues[`externalId_${connectorId}`]
        connector.connectorType = formValues[`connectorType_${connectorId}`]
        connector.installationPhaseMode = formValues[`installationPhaseMode_${connectorId}`]
        connector.installationPhase = formValues[`installationPhase_${connectorId}`]
        connector.installationCurrent = formValues[`ic_${connectorId}`]
        connector.userCurrent = formValues[`uc_${connectorId}`]
        connector.loadBalancerOfflineCurrent = formValues[`lbc_${connectorId}`]
        connector.loadBalancerOfflinePhase = formValues[`lbOfflinePhase_${connectorId}`]

        return connector
    })

    return {
        ...tempChargePoint,
        name: formValues.name,
        earthingSystem: formValues.earthingSystem,
        supplyCurrent: formValues.supplyCurrent,
        nfcEnabled: formValues.nfcEnabled,
        installationPhaseMode: formValues.installationPhaseMode,
        connectorPhaseRotation: formValues.connectorPhaseRotation,
        additionalInfo: tempChargePoint.additionalInfo,
        connectors,
    }
}

export const mapChargerToChargerInformation = (chargePoint: ChargePoint) => {
    return {
        description: chargePoint?.additionalInfo?.description,
        partnerDescription: chargePoint?.additionalInfo?.partnerDescription,
        allowConnectCurrent: chargePoint?.additionalInfo?.allowConnectCurrent,
        callbackEnabledApiCustomerId: chargePoint?.additionalInfo?.callbackEnabledApiCustomerId,
        hasServiceAgreement: chargePoint?.additionalInfo?.hasServiceAgreement,
        partnerAccessible: chargePoint?.additionalInfo?.partnerAccessible,
        installationDate: chargePoint?.additionalInfo?.installationDate,
        statusIntervalId: chargePoint?.additionalInfo?.statusIntervalId,
        hardwareVersionId: chargePoint?.hardwareVersionId,
        wifiSsid: chargePoint?.additionalInfo?.wifiSsid,
        wifiPassword: chargePoint?.additionalInfo?.wifiPassword,
        countrySettingsId: chargePoint?.countrySettingsId,
        poolId: chargePoint?.poolId,
        ownerId: chargePoint?.ownerId,
        debugEnabled: chargePoint?.debugEnabled,
        connector1ExternalId: chargePoint?.connectors && chargePoint?.connectors[0].externalId,
        connector2ExternalId:
            chargePoint?.connectors && chargePoint?.connectors.length > 1 ? chargePoint?.connectors[1].externalId : '',
        externalServerId: chargePoint.additionalInfo?.externalServerId,
    }
}

const mapChargerSettingsFormValues = (formValues: IChargerSettingsFormInput) => {
    return {
        description: formValues.description,
        partnerDescription: formValues.partnerDescription,
        allowConnectCurrent: formValues.allowConnectCurrent,
        hardwareVersionId: formValues.hardwareVersionId,
        hasServiceAgreement: formValues.hasServiceAgreement,
        partnerAccessible: formValues.partnerAccessible,
        installationDate: formValues.installationDate,
        statusIntervalId: formValues.statusIntervalId ? formValues.statusIntervalId : undefined,
        wifiSsid: formValues.wifiSsid,
        wifiPassword: formValues.wifiPassword,
        countrySettingsId: formValues.countrySettingsId,
        poolId: formValues.pool,
        ownerId: formValues.ownerInfo_0,
        debugEnabled: formValues.debugEnabled,
        connector1ExternalId: formValues.externalId_1,
        connector2ExternalId: formValues.externalId_2,
        connector1OwnerId: formValues.ownerInfo_1,
        connector2OwnerId: formValues.ownerInfo_2,
    }
}

export const mapChargerSettingsToChargerInformation = (
    formValues: IChargerSettingsFormInput,
    chargePoint: ChargePoint
) => ({
    ...mapChargerSettingsFormValues(formValues),
    externalServerId: chargePoint.additionalInfo?.externalServerId,
    callbackEnabledApiCustomerId: chargePoint.additionalInfo?.callbackEnabledApiCustomerId,
})

export const mapFormValuesToChargerInformation = (formValues: IChargerInformationFormInput) => ({
    ...mapChargerSettingsFormValues(formValues),
    externalServerId: formValues.externalServerId,
    callbackEnabledApiCustomerId: formValues.callbackEnabledApiCustomerId,
})

export function mapCapiChargepoint(chargePoint: ChargePoint, formValues: ICapiFormInput): ChargePoint {
    const tempChargePoint = JSON.parse(JSON.stringify(chargePoint))

    const connectors = tempChargePoint.connectors?.map((connector) => {
        const connectorId = connector.connectorId as 1 | 2
        connector.externalId = formValues[`externalId_${connectorId}`]

        connector.connectorType = formValues[`connectorType_${connectorId}`]
        connector.installationPhaseMode = formValues[`installationPhaseMode_${connectorId}`]
        connector.installationPhase = formValues[`installationPhase_${connectorId}`]
        connector.installationCurrent = formValues[`ic_${connectorId}`]
        connector.userCurrent = formValues[`uc_${connectorId}`]
        connector.loadBalancerOfflineCurrent = formValues[`lbc_${connectorId}`]
        connector.loadBalancerOfflinePhase = formValues[`lbOfflinePhase_${connectorId}`]

        return connector
    })

    return {
        ...tempChargePoint,
        name: formValues.name,
        supplyCurrent: formValues.supplyCurrent,
        nfcEnabled: formValues.nfcEnabled,
        additionalInfo: tempChargePoint.additionalInfo,
        connectors,
    }
}
